import { Modal } from 'forms';
import React, { useCallback, useState } from 'react';
import { PopupData } from '../types';
import PwsPopupContent from './PwsPopupContent';

interface Props {
    popup: PopupData;
    onClose?: () => void;
}

const PwsPopupGlobalModal = (props: Props) => {
    const [show, setShow] = useState(!!props.popup);
    const handleClose = useCallback(() => {
        setShow(false);
        if (props.onClose) {
            props.onClose();
        }
    }, []);

    const handleLinkButtonClick = useCallback(() => {
        handleClose();
    }, [handleClose]);

    return <Modal
        show={show}
        onClose={handleClose}
        className="pws-popup-modal"
        backdropClassName="pws-popup-modal-backdrop">
        <PwsPopupContent popup={props.popup} onLinkButtonClick={handleLinkButtonClick} />
    </Modal>;
};

export default PwsPopupGlobalModal;
